import { Component, ElementRef, Input, ViewChild, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LotsService } from '../../services/lots.service';
import { LotPopupInfo } from '@zayan-erp/home-building';
import { SvgIconsComponent } from '@zayan-erp/shared';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbModalService } from '@zayan-erp/shared';

@Component({
  selector: 'app-lot-info-popup',
  standalone: true,
  imports: [SvgIconsComponent, CommonModule],
  templateUrl: './lot-info-popup.component.html'
})
export class LotInfoPopupComponent {
  @Input() lotId!: string;
  _modalService = inject(NgbModal);
  _ngbModalService = inject(NgbModalService);
  @ViewChild('lotInfoModal') lotInfoModal!: ElementRef;

  #lotsService = inject(LotsService);
  selectedLotInfo: LotPopupInfo | null = null;

  openModal(): void {
    if (this.lotId) {
      this.#lotsService.getLotPopupInfoById(this.lotId).subscribe((lot: LotPopupInfo | null) => {
        this.selectedLotInfo = lot;
        this._modalService.open(this.lotInfoModal, {
          ...this._ngbModalService.centerModal,
          size: 'lg'
        });
      });
    }
  }
}
